import MicrosoftLogin from './MicrosoftLogin';

export default MicrosoftLogin;
